import React from 'react';
import { StyleSheet, Button, TouchableOpacity } from 'react-native';

import FormField from './FormField';
import Item from '../Item';

const styles = StyleSheet.create({
    touchContent: {
        width: '100%',
    },
});

interface Props {
    item: {
        type_id: string;
        name: string;
        description: string;
        image: string;
    };
    setFieldValue: (item: any) => void;
    expanded: boolean;
    setExpanded: (isExpanded: boolean) => void;
}

const ItemForm: React.FC<Props> = ({
    item,
    setFieldValue,
    expanded,
    setExpanded,
}) => {
    return (
        <>
            <TouchableOpacity
                onPress={() => {
                    console.log('Choose', item);
                    setExpanded(!expanded);
                    if (setFieldValue !== null) {
                        setFieldValue(item);
                    }
                }}
                style={styles.touchContent}
            >
                <Item item={item} />
            </TouchableOpacity>
            <Button
                title="Select"
                onPress={() => {
                    console.log('Choose by button', item.type_id);
                    setExpanded(!expanded);
                    if (setFieldValue !== null) {
                        setFieldValue(item);
                    }
                }}
            />
        </>
    );
};

export default FormField(ItemForm);
